function maskValue(value, mask) {
  if (!value || !mask) return value

  let maskedValue = ''
  let valueIndex = 0

  for (let i = 0; i < mask.length && valueIndex < value.length; i++) {
    const maskChar = mask[i]

    if (maskChar === '#') {
      const char = value[valueIndex]
      if (/\d/.test(char)) {
        maskedValue += char
        valueIndex++
      } else {
        valueIndex++
        i--
      }
    } else {
      maskedValue += maskChar
      if (value[valueIndex] === maskChar) {
        valueIndex++
      }
    }
  }

  return maskedValue
}

function unmaskValue(value, mask) {
  if (!value || !mask) return value

  let unmasked = ''
  for (let i = 0; i < value.length; i++) {
    const char = value[i]
    const maskChar = mask[i] || '#'

    if (maskChar === '#' && /\d/.test(char)) {
      unmasked += char
    } else if (maskChar !== '#' && char === maskChar) {
      // intentionally empty — skip mask characters
    } else if (/\d/.test(char)) {
      unmasked += char
    }
  }

  return unmasked
}

function handleInput(event, mask) {
  const input = event.target
  const cursorPosition = input.selectionStart
  const oldValue = input.value

  const rawValue = unmaskValue(oldValue, mask)
  const newValue = maskValue(rawValue, mask)

  if (newValue !== oldValue) {
    input.value = newValue

    input.dispatchEvent(new Event('input', { bubbles: true }))

    let newCursorPos = cursorPosition
    const addedChars = newValue.length - oldValue.length
    if (addedChars > 0) {
      newCursorPos += addedChars
    }

    while (newCursorPos < mask.length && mask[newCursorPos] !== '#') {
      newCursorPos++
    }

    input.setSelectionRange(newCursorPos, newCursorPos)
  }
}

function handleKeydown(event, mask) {
  const input = event.target
  const key = event.key

  if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter', 'Home', 'End'].includes(key)) {
    return
  }

  if (event.ctrlKey || event.metaKey) {
    return
  }

  if (!/^\d$/.test(key)) {
    event.preventDefault()
    return
  }

  const maxDigits = (mask.match(/#/g) || []).length
  const currentDigits = unmaskValue(input.value, mask).length

  if (currentDigits >= maxDigits) {
    event.preventDefault()
  }
}

export const MaskDirective = {
  mounted(el, binding) {
    const mask = binding.value
    if (!mask) return

    el._mask = mask

    if (el.value) {
      const rawValue = unmaskValue(el.value, mask)
      el.value = maskValue(rawValue, mask)
    }

    el._maskInputHandler = (event) => handleInput(event, el._mask)
    el._maskKeydownHandler = (event) => handleKeydown(event, el._mask)

    el.addEventListener('input', el._maskInputHandler)
    el.addEventListener('keydown', el._maskKeydownHandler)
  },

  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      el._mask = binding.value
    }

    if (el.value && el._mask) {
      const rawValue = unmaskValue(el.value, el._mask)
      const maskedValue = maskValue(rawValue, el._mask)
      if (el.value !== maskedValue) {
        el.value = maskedValue
      }
    }
  },

  unmounted(el) {
    if (el._maskInputHandler) {
      el.removeEventListener('input', el._maskInputHandler)
    }
    if (el._maskKeydownHandler) {
      el.removeEventListener('keydown', el._maskKeydownHandler)
    }
    delete el._mask
    delete el._maskInputHandler
    delete el._maskKeydownHandler
  },
}

export default MaskDirective
